import React from 'react';
import PropTypes from 'prop-types';
import LegendZoomButton from "./Legend/LegendZoomButton";

const ZoomIcons = ({ zoomInFunction, zoomOutFunction, scale, minScale, maxScale, onClick }) => (
   <div className="map-controls">
      <LegendZoomButton
         isZoomIn
         onClick={e => onClick(e, zoomInFunction)}
         inActive={scale === maxScale}
      />

      <LegendZoomButton
         onClick={e => onClick(e, zoomOutFunction)}
         inActive={scale === minScale}
      />
   </div>
);

ZoomIcons.propTypes = {
   zoomInFunction: PropTypes.func,
   zoomOutFunction: PropTypes.func,
   scale: PropTypes.any,
   minScale: PropTypes.any,
   maxScale: PropTypes.any,
   isMobile: PropTypes.bool
};

export default ZoomIcons;
